// QUICK ADD BUTTONS
var isSubmitting = false; // flag to indicate if an AJAX call is currently in progress

$(document).on('submit', '#quickShopForm', function (e) {
    e.preventDefault(); // prevent the form from submitting normally

    if (isSubmitting) {
        return; // if an AJAX call is already in progress, do nothing
    }

    isSubmitting = true; // set the flag to indicate that an AJAX call is now in progress
    $(this).find('button[type="submit"]').prop('disabled', false); // disable the submit button
    var formData = $(this).serialize(); // get the form data
    var currentForm = $(this); // store a reference to the current form

    $.ajax({
        type: 'POST',
        url: '/cart/add.js', // Shopify cart API endpoint for adding products
        data: formData,
        dataType: 'json',
        success: function () {
            $.ajax({
                type: 'GET',
                dataType: 'html',
                success: function (html) {
                    $('#CartDrawer').html($(html).find('#CartDrawer').html());
                    var cart = new theme.CartDrawer();
                    cart.init();
                    cart.open();
                }
            });
            currentForm.find('button[type="submit"]').prop('disabled', false); // re-enable the submit button
            isSubmitting = false; // set the flag to indicate that the AJAX call is now complete
        },
        error: function () {
            isSubmitting = false; // reset flag on error
        }
    });
});

$(document).on('change', 'input[type="radio"]', function () {
    $(this).closest('form').submit(); // automatically submit the form when a radio button is selected
});